// extracted by mini-css-extract-plugin
export var chip = "_4t-0";
export var filterDropdown = "_4t-5";
export var filterItem = "_4t-6";
export var icon = "_4t-1";
export var removeButton = "_4t-3";
export var removeIcon = "_4t-4";
export var separator = "_4t-2";